<template>
    <SmartLink :route="{ name: 'promo' }" class="logo">
        <UkaskoLogo />
    </SmartLink>
</template>

<script>
import { UkaskoLogo } from '@/shared/ui/icons';
import { SmartLink } from '@/shared/ui/link';

export default {
  components: { UkaskoLogo, SmartLink },
};
</script>
